const hindi = {
    name: "Hindi",
    native_name: "हिंदी",
    code: "hi",
  };
  
  const hi = {
    translation: {
      report_bug: "बग रिपोर्ट करें",
      import: "इम्पोर्ट",
      file: "फ़ाइल",
      new: "नया",
      new_window: "नई विंडो",
      open: "खोलें",
      save: "सेव",
      save_as: "के रूप में सेव करें",
      save_as_template: "टेम्पलेट के रूप में सेव करें",
      template_saved: "टेम्पलेट सेव हो गया!",
      rename: "नाम बदलें",
      delete_diagram: "डायग्राम हटाएं",
      are_you_sure_delete_diagram:
        "क्या आप वाकई इस डायग्राम को हटाना चाहते हैं? यह क्रिया अपरिवर्तनीय है।",
      oops_smth_went_wrong: "उफ़! कुछ गलत हो गया।",
      import_diagram: "डायग्राम इम्पोर्ट करें",
      import_from_source: "SQL से इम्पोर्ट करें",
      export_as: "के रूप में एक्सपोर्ट करें",
      export_source: "SQL एक्सपोर्ट करें",
      models: "मॉडल्स",
      exit: "बाहर निकलें",
      edit: "एडिट करें",
      undo: "पूर्ववत करें",
      redo: "फिर से करें",
      clear: "साफ़ करें",
      are_you_sure_clear:
        "क्या आप वाकई इस डायग्राम को साफ़ करना चाहते हैं? यह अपरिवर्तनीय है।",
      cut: "काटें",
      copy: "कॉपी करें",
      paste: "पेस्ट करें",
      duplicate: "प्रतिलिपि बनाएं",
      delete: "हटाएं",
      copy_as_image: "इमेज के रूप में कॉपी करें",
      view: "दृश्य",
      header: "मेनूबार",
      sidebar: "साइडबार",
      issues: "समस्याएं",
      presentation_mode: "प्रस्तुति मोड",
      strict_mode: "स्ट्रिक्ट मोड",
      field_details: "फ़ील्ड डिटेल्स",
      reset_view: "दृश्य रीसेट करें",
      show_grid: "ग्रिड दिखाएं",
      show_cardinality: "कार्डिनैलिटी दिखाएं",
      theme: "थीम",
      light: "प्रकाश",
      dark: "अंधकार",
      zoom_in: "ज़ूम इन",
      zoom_out: "ज़ूम आउट",
      fullscreen: "पूर्ण स्क्रीन",
      settings: "सेटिंग्स",
      show_timeline: "टाइमलाइन दिखाएं",
      autosave: "ऑटोसेव",
      panning: "पैनिंग",
      table_width: "टेबल की चौड़ाई",
      language: "भाषा",
      flush_storage: "स्टोरेज साफ़ करें",
      are_you_sure_flush_storage:
        "क्या आप वाकई स्टोरेज को साफ़ करना चाहते हैं? यह सभी आपके डायग्राम और कस्टम टेम्पलेट्स को अपरिवर्तनीय रूप से हटा देगा।",
      storage_flushed: "स्टोरेज साफ़ किया गया",
      help: "मदद",
      shortcuts: "शॉर्टकट्स",
      ask_on_discord: "हमसे Discord पर पूछें",
      feedback: "फीडबॅक",
      no_changes: "कोई बदलाव नहीं",
      loading: "लोड हो रहा है...",
      last_saved: "आखिरी बार सेव्हड",
      saving: "सेव हो रहा है...",
      failed_to_save: "सेव करने में विफल",
      fit_window_reset: "विंडो फिट करें / रीसेट करें",
      zoom: "ज़ूम",
      add_table: "टेबल जोड़ें",
      add_area: "एरिया जोड़ें",
      add_note: "नोट जोड़ें",
      add_type: "प्रकार जोड़ें",
      to_do: "करने के लिए",
      tables: "टेबल्स",
      relationships: "संबंध",
      subject_areas: "सब्जेक्ट एरियाज",
      notes: "नोट्स",
      types: "प्रकार",
      search: "खोजें...",
      no_tables: "कोई टेबल्स नहीं",
      no_tables_text: "अपना डायग्राम बनाना शुरू करें!",
      no_relationships: "कोई संबंध नहीं",
      no_relationships_text: "फील्ड्स को कनेक्ट करने के लिए खींचें और संबंध बनाएं!",
      no_subject_areas: "कोई विषय एरियाज नहीं",
      no_subject_areas_text: "ग्रूप टेबल्स को सब्जेक्ट एरियाज जोड़ें!",
      no_notes: "कोई नोट्स नहीं",
      no_notes_text: "अतिरिक्त जानकारी रिकॉर्ड करने के लिए नोट्स का उपयोग करें",
      no_types: "कोई प्रकार नहीं",
      no_types_text: "अपने स्वयं के कस्टम डेटा प्रकार बनाएं",
      no_issues: "कोई समस्याएं नहीं पाए गए।",
      strict_mode_is_on_no_issues:
        "स्ट्रिक्ट मोड बंद है इसलिए कोई समस्याएं नहीं दिखाए जाएंगे।",
      name: "नाम",
      type: "प्रकार",
      null: "Null",
      not_null: "नॉट null",
      primary: "प्राथमिक",
      unique: "युनिक",
      autoincrement: "स्वतः वाढ",
      default_value: "डिफ़ॉल्ट",
      check: "चेक एक्सप्रेशन",
      this_will_appear_as_is: "*यह जेनरेटेड स्क्रिप्ट में जैसा है वैसा ही दिखेगा।",
      comment: "टिप्पणी",
      add_field: "फ़ील्ड जोड़ें",
      values: "व्हॅल्यूज",
      size: "साइज",
      precision: "सटीकता",
      set_precision: "सटीकता सेट करें: (साइज, डिजिट्स)",
      use_for_batch_input: "Use , बैच इनपुट के लिए",
      indices: "इंडायसेस",
      add_index: "इंडेक्स जोड़ें",
      select_fields: "फ़ील्ड्स चुनें",
      title: "शीर्षक",
      not_set: "सेट नहीं किया गया",
      foreign: "फॉरेन",
      cardinality: "कार्डिनैलिटी",
      on_update: "अपडेट पर",
      on_delete: "हटाने पर",
      swap: "स्वैप",
      one_to_one: "एक से एक",
      one_to_many: "एक से कई",
      many_to_one: "कई से एक",
      content: "कंटेंट",
      types_info:
        "यह सुविधा object-relational DBMS जैसे PostgreSQL के लिए है।\nयदि MySQL या MariaDB के लिए उपयोग किया जाता है, तो एक JSON प्रकार जेनरेट किया जाएगा जिसमें संबंधित json वैधता जांच होगी।\nयदि SQLite के लिए उपयोग किया जाता है तो इसे BLOB में परिवर्तित किया जाएगा।\nयदि MSSQL के लिए उपयोग किया जाता है तो पहले फ़ील्ड के लिए एक प्रकार उपनाम जेनरेट किया जाएगा।",
      table_deleted: "टेबल हटाई गई",
      area_deleted: "एरिया हटाया गया",
      note_deleted: "नोट हटाया गया",
      relationship_deleted: "संबंध हटाया गया",
      type_deleted: "प्रकार हटाया गया",
      cannot_connect: "कनेक्ट नहीं कर सकते, कॉलम के प्रकार अलग-अलग हैं",
      copied_to_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
      create_new_diagram: "नया डायग्राम बनाएं",
      cancel: "रद्द करें",
      open_diagram: "डायग्राम खोलें",
      rename_diagram: "डायग्राम का नाम बदलें",
      export: "एक्सपोर्ट",
      export_image: "एक्सपोर्ट इमेज",
      create: "बनाएं",
      confirm: "पुष्टि करें",
      last_modified: "अंतिम बार मॉडिफाइड",
      drag_and_drop_files: "फ़ाइल को यहां खींचें और छोड़ें या अपलोड करने के लिए क्लिक करें।",
      support_json_and_ddb: "JSON और DDB फ़ाइलें समर्थित हैं",
      upload_sql_to_generate_diagrams:
        "अपनी टेबल और कॉलम को स्वचालित रूप से जेनरेट करने के लिए एक sql फ़ाइल अपलोड करें।",
      overwrite_existing_diagram: "मौजूदा डायग्राम को अधिलेखित करें",
      only_mysql_supported:
        "*फिलहाल केवल MySQL स्क्रिप्ट्स को लोड करना समर्थित है।",
      blank: "खाली",
      filename: "फ़ाइलनाम",
      table_w_no_name: "नाम के बिना टेबल घोषित की गई",
      duplicate_table_by_name: "नाम से डुप्लिकेट टेबल '{{tableName}}'",
      empty_field_name: "टेबल '{{tableName}}' में खाली फ़ील्ड `नाम`",
      empty_field_type: "टेबल '{{tableName}}' में खाली फ़ील्ड `प्रकार`",
      no_values_for_field:
        "टेबल '{{tableName}}' के फ़ील्ड '{{fieldName}}' का प्रकार `{{type}}` है लेकिन कोई व्हॅल्यू निर्दिष्ट नहीं की गयी है",
      default_doesnt_match_type:
        "टेबल '{{tableName}}' में फ़ील्ड '{{fieldName}}' की डिफ़ॉल्ट व्हॅल्यू उसके प्रकार से मेल नहीं खाती",
      not_null_is_null:
        "टेबल '{{tableName}}' के फ़ील्ड '{{fieldName}}' की व्हॅल्यू NOT NULL है लेकिन डिफ़ॉल्ट NULL है",
      duplicate_fields:
        "टेबल '{{tableName}}' में नाम '{{fieldName}}' वाले डुप्लिकेट टेबल फ़ील्ड्स",
      duplicate_index:
        "टेबल '{{tableName}}' में नाम '{{indexName}}' वाला डुप्लिकेट इंडेक्स",
      empty_index: "टेबल '{{tableName}}' में इंडेक्स कोई कॉलम इंडेक्स नहीं करता",
      no_primary_key: "टेबल '{{tableName}}' में कोई प्राथमिक कुंजी नहीं है",
      type_with_no_name: "कोई नाम नहीं होने वाले प्रकार को घोषित किया",
      duplicate_types: "नाम '{{typeName}}' वाले डुप्लिकेट प्रकार",
      type_w_no_fields: "कोई फ़ील्ड्स नहीं होने वाले प्रकार '{{typeName}}' को घोषित किया",
      empty_type_field_name: "प्रकार '{{typeName}}' में खाली फ़ील्ड `नाम`",
      empty_type_field_type: "प्रकार '{{typeName}}' में खाली फ़ील्ड `प्रकार`",
      no_values_for_type_field:
        "प्रकार '{{typeName}}' के फ़ील्ड '{{fieldName}}' का प्रकार `{{type}}` है लेकिन कोई व्हॅल्यू निर्दिष्ट नहीं की गयी है",
      duplicate_type_fields:
        "प्रकार '{{typeName}}' में नाम '{{fieldName}}' वाले डुप्लिकेट प्रकार फ़ील्ड्स",
      duplicate_reference: "नाम '{{refName}}' वाला डुप्लिकेट संदर्भ",
      circular_dependency: "टेबल '{{refName}}' में परिपत्र निर्भरता",
      timeline: "समयरेखा",
      priority: "प्राथमिकता",
      none: "कोई नहीं",
      low: "निम्न",
      medium: "मध्यम",
      high: "उच्च",
      sort_by: "द्वारा क्रमबद्ध करें",
      my_order: "मेरा क्रम",
      completed: "पूर्ण",
      alphabetically: "वर्णानुक्रम में",
      add_task: "कार्य जोड़ें",
      details: "डिटेल्स",
      no_tasks: "आपके पास अभी तक कोई कार्य नहीं है।",
      no_activity: "आपके पास अभी तक कोई गतिविधि नहीं है।",
      move_element: "{{name}} को {{coords}} पर ले जाएँ",
      edit_area: "{{extra}} एडिट एरिया {{areaName}}",
      delete_area: "एरिया हटाएं {{areaName}}",
      edit_note: "{{extra}} नोट एडिट करें {{noteTitle}}",
      delete_note: "नोट हटाएं {{noteTitle}}",
      edit_table: "{{extra}} टेबल एडिट करें {{tableName}}",
      delete_table: "टेबल हटाएं {{tableName}}",
      edit_type: "{{extra}} प्रकार एडिट करें {{typeName}}",
      delete_type: "प्रकार हटाएं {{typeName}}",
      add_relationship: "संबंध जोड़ें",
      edit_relationship: "{{extra}} संबंध एडिट करें {{refName}}",
      delete_relationship: "संबंध हटाएं {{refName}}",
      not_found: "नहीं मिला",
    },
  };
  
  export { hi, hindi };
  